<template>
    <div>
        <div class="my-8 flex justify-between">
            <h1 class="text-center text-3xl">
                Detalles de grupo de orden
                <strong class="text-theme-primary">
                    #{{ itemComponent.id }}
                </strong>
            </h1>
            <div class="flex items-center">
                <div>
                    <app-button
                        icon
                        circle
                        color="brand-purple"
                        @click="getBaseItem"
                    >
                        <reload-icon class="text-white h-5 w-5" />
                    </app-button>
                </div>
            </div>
        </div>
        <div v-if="hasLoadedBase" class="my-4 flex flex-wrap">
            <div class="w-full md:w-1/2 flex flex-col my-2">
                <strong>Fecha de Fragmentación </strong>
                <span class="mt-2 ml-2">
                    {{ itemComponent.createdAt | date }}
                </span>
            </div>
            <div class="w-full md:w-1/2 flex flex-col my-2">
                <strong>Fecha de última actualización </strong>
                <span class="mt-2 ml-2">
                    {{ itemComponent.updatedAt | date }}
                </span>
            </div>
            <div class="w-full md:w-1/2 flex flex-col my-2">
                <strong>Estado de pago del grupo de ordenes </strong>
                <span
                    class="mt-2 ml-2"
                    :class="
                        $data.$ordersGroupsPaymentStatusMessageClass[
                            itemComponent.paymentStatusGroup
                        ]
                    "
                >
                    {{
                        $data.$ordersGroupsPaymentStatusCodes[
                            itemComponent.paymentStatusGroup
                        ]
                    }}
                </span>
            </div>
            <div class="w-full md:w-1/2 flex flex-col my-2">
                <strong>Estado del grupo de ordenes </strong>
                <span
                    class="mt-2 ml-2"
                    :class="
                        $data.$ordersStatusesGroupMessageClass[
                            itemComponent.deliveryStatusGroup
                        ]
                    "
                >
                    {{
                        $data.$ordersStatusesGroupCodes[
                            itemComponent.deliveryStatusGroup
                        ]
                    }}
                </span>
            </div>

            <div class="flex overflow-x-auto mt-4 w-full">
                <div
                    v-for="column in itemComponent.orders"
                    :key="column.id"
                    class="mr-1"
                >
                    <div
                        class="border rounded-lg border-secondary w-72 px-2 pt-3 h-full"
                    >
                        <router-link
                            :to="`/app/orders/detail/${column.id}`"
                            class="btn-a p-0"
                        >
                            <h3 class="text-lg">
                                Orden #
                                {{ column.id }}
                            </h3>
                        </router-link>

                        <div class="flex justify-center flex-col">
                            <span class="my-1">
                                <strong>Proveedor : </strong>
                                <span class="capitalize">
                                    {{
                                        column.supplyMerchant.merchantType
                                            | merchantInfo("icon", "type")
                                    }}
                                    {{ column.supplyMerchant.name }}
                                </span>
                            </span>
                            <span class="my-1">
                                <strong>Dirección proveedor : </strong>
                                <span>
                                    {{
                                        column.supplyMerchant.address
                                            | address
                                            | cut(28)
                                    }}
                                    {{
                                        `${
                                            column.supplyMerchant
                                                .addressComplement
                                        },${
                                            column.supplyMerchant.neighborhood
                                                ? `barrio ${column.supplyMerchant.neighborhood} de `
                                                : ""
                                        }${column.supplyMerchant.city}`.trim()
                                    }}
                                </span>
                            </span>

                            <span class="my-1">
                                <strong> Estado : </strong>
                                <span
                                    :class="
                                        $data.$ordersStatusesMessageClass[
                                            column.deliveryStatus
                                        ]
                                    "
                                >
                                    {{
                                        $data.$ordersStatusesCodes[
                                            column.deliveryStatus
                                        ]
                                    }}
                                </span>
                            </span>

                            <span>
                                <strong> Estado de pago : </strong>
                                <span
                                    :class="
                                        $data.$ordersStatusesMessageClass[
                                            column.deliveryStatus
                                        ]
                                    "
                                >
                                    {{
                                        $data.$ordersStatusesCodes[
                                            column.deliveryStatus
                                        ]
                                    }}
                                </span>
                            </span>

                            <span class="my-1">
                                <strong> 🗓 Actualización : </strong>
                                <span> {{ column.updatedAt | date }} </span>
                            </span>

                            <span class="my-1">
                                <strong> Total: </strong>
                                <span> {{ column.total | money }} </span>
                            </span>

                            <span class="my-1">
                                <strong> Precio de productos: </strong>
                                <span>
                                    {{
                                        column.referencesValueWithDiscount
                                            | money
                                    }}
                                </span>
                            </span>

                            <span class="mt-1">
                                <strong> Productos: </strong>
                                <span>{{ column.references.length }}</span>
                            </span>

                            <reference-table-item-2
                                v-for="flex in column.references"
                                :key="flex.id"
                                :reference="flex"
                                class="my-2"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import {
    ordersStatusesGroupCodes,
    ordersStatusesGroupMessageClass
} from "@/common/fields/delivery-status-group-codes";
import {
    ordersGroupsPaymentStatusCodes,
    ordersGroupsPaymentStatusMessageClass
} from "@/common/fields/orders-groups-payment-status-group-codes";
import {
    paymentStatusesCodes,
    paymentStatusesMessageClass
} from "@/common/fields/orders-payment-status-codes";
import {
    ordersStatusesCodes,
    ordersStatusesMessageClass
} from "@/common/fields/orders-status-codes";

import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import ReferenceTableItem2 from "@/components/references/ReferenceTableItem2.vue";

export default {
    name: "OrdersGroupsIndex",
    components: { ReferenceTableItem2, ReloadIcon },
    data: () => ({
        id: null,
        hasLoadedBase: false,
        itemComponent: {
            id: 1,
            type: "store-store",
            deliveryStatusGroup: "nod",
            paymentStatusGroup: "nop",
            createdAt: "2023-06-24T23:25:31.338Z",
            updatedAt: "2023-06-24T23:25:31.338Z",
            orders: []
        },
        $ordersStatusesGroupCodes: ordersStatusesGroupCodes,
        $ordersStatusesGroupMessageClass: ordersStatusesGroupMessageClass,
        $ordersGroupsPaymentStatusMessageClass:
            ordersGroupsPaymentStatusMessageClass,
        $ordersGroupsPaymentStatusCodes: ordersGroupsPaymentStatusCodes,
        $paymentStatusesCodes: paymentStatusesCodes,
        $paymentStatusesMessageClass: paymentStatusesMessageClass,
        $ordersStatusesCodes: ordersStatusesCodes,
        $ordersStatusesMessageClass: ordersStatusesMessageClass
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if ("id" in this.$route.params) {
            if (
                !(await verifyPagePermission(
                    "orderGroup:Get",
                    "/app/orders-groups"
                ))
            )
                return;
            this.id = Number(this.$route.params.id);
            return this.getBaseItem();
        }
    },
    methods: {
        ...mapActions("orders", ["getOrderGroupById"]),
        async getBaseItem() {
            this.isLoading = true;
            this.$loading.show();
            try {
                this.itemComponent = await this.getOrderGroupById({
                    id: this.id
                });
                this.hasLoadedBase = true;
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
                if (error.statusCode === 404) {
                    this.$router.push("/app/orders");
                }
            }
        }
    }
};
</script>
